import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import configService from '../services/config.service';
import { useTranslation } from 'react-i18next';
import { Alert } from '../services/notiflix.service';

const ChatwootWidget = () => {
  const { user: authUser } = useSelector((state) => state.auth);
  const language = useSelector((state) => state.languageReducer.language);
  const { t } = useTranslation(['profile']);

  useEffect(() => {
    if (!authUser) return;
    if (!window.chatwootSDK) {
      window.chatwootSettings = {
        position: 'right',
        type: 'expanded_bubble',
        launcherTitle: t('profile:need_help'),
      };

      const existingScript = document.querySelector(
        'script[src="https://app.chatwoot.com/packs/js/sdk.js"]',
      );

      // technically we can reset the widget if the language changes.
      // but we'll leave that for future improvement.
      if (!existingScript) {
        (function (d, t) {
          const g = d.createElement(t),
            s = d.getElementsByTagName(t)[0];
          g.src = 'https://app.chatwoot.com/packs/js/sdk.js';
          g.defer = true;
          g.async = true;
          s.parentNode.insertBefore(g, s);

          g.onload = function () {
            window.chatwootSDK.run({
              websiteToken: configService.chatWootToken(),
              baseUrl: 'https://app.chatwoot.com',
            });
          };
        })(document, 'script');

        window.addEventListener('chatwoot:ready', function () {
          let userDetails = {
            identifier: String(authUser.userId),
            name: authUser.userName,
            email: authUser.email,
            language: language || 'en',
            identifier_hash: authUser.chatwootIDHash, // Pass this to Chatwoot
          };

          // Add phone number if available
          if (authUser.phoneNumber) {
            userDetails.phone_number = authUser.phoneNumber;
          }

          window.$chatwoot.setUser(String(authUser.userId), userDetails);
          window.$chatwoot.setCustomAttributes({
            userID: String(authUser.userId),
            platform_href: `${configService.adminPlatformUserUrl()}${String(authUser.userId)}`,
          });
        });

        window.addEventListener('chatwoot:error', function (error) {
          Alert.error(error.message);
        });
      }
    }
  }, [authUser, language, t]);

  return null;
};

export default ChatwootWidget;
